/**
 * DataQualityFooter - Shows data completeness and last updated info
 * Pure presentational component wrapped with React.memo
 */

import { memo } from 'react';

interface DataQualityFooterProps {
  completeness: number;
  lastUpdated: string;
}

function DataQualityFooterComponent({ completeness, lastUpdated }: DataQualityFooterProps) {
  return (
    <div className="pt-4 border-t border-gray-200 flex items-center justify-between text-sm text-gray-500">
      <div className="flex items-center gap-2">
        <span>Data completeness:</span>
        <div className="w-24 h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-primary-500 rounded-full"
            style={{ width: `${completeness * 100}%` }}
          />
        </div>
        <span>{Math.round(completeness * 100)}%</span>
      </div>
      <div>Last updated: {new Date(lastUpdated).toLocaleDateString()}</div>
    </div>
  );
}

export const DataQualityFooter = memo(DataQualityFooterComponent);
